import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Author } from '@interfaces/authors';
import { ContentType } from '@tracking';

interface NewsletterFeedItemProps {
  className?: string;
  children: React.ReactNode;
  newsletterId: number;
  newsletterAuthor: Author;
  contentIndex?: number;
}

const NewsletterFeedItem = ({
  children,
  className,
  contentIndex,
  newsletterId,
  newsletterAuthor,
}: NewsletterFeedItemProps) => {
  const { Track } = useEventTracking({
    contentType: ContentType.Newsletter,
    contentId: newsletterId,
    creatorIds: newsletterAuthor ? [newsletterAuthor.id] : null,
    contentIndex: contentIndex,
  });

  return (
    <Track>
      <article className={clsx(className, 'flex')}>{children}</article>
    </Track>
  );
};

export default NewsletterFeedItem;
